import React from "react";
import { Grid, TextField, MenuItem, GridProps, TextFieldProps } from "@mui/material";

interface Option {
  label: string;
  value: string | number;
}

interface FormSelectFieldProps
  extends Omit<TextFieldProps, "name" | "value" | "onChange" | "onBlur" | "select" | "error"> {
  fieldName: string;
  label: React.ReactNode;
  value?: string | number;
  error?: boolean;
  helperText?: React.ReactNode;
  disabled?: boolean;
  options: Option[];
  onChange: (value: string, fieldName: string) => void;
  onBlur?: (fieldName: string, value: string) => void;
  gridProps?: GridProps;
}

const FormSelectField: React.FC<FormSelectFieldProps> = ({
  fieldName,
  label,
  value = "",
  error,
  disabled = false,
  options,
  onChange,
  onBlur,
  gridProps = { md: 4, sm: 12, xs: 12 },
  ...rest
}) => {
  return (
    <Grid item {...gridProps}>
      {/* <Typography level="body-sm">{label}</Typography> */}
      <TextField
        fullWidth
        select
        id={`${fieldName}-select`}
        name={fieldName}
        label={label}
        disabled={disabled}
        value={value}
        error={Boolean(error)}
        helperText={error ?? undefined}
        onChange={(e) => onChange(e.target.value, fieldName)}
        // onBlur={(e) => onBlur?.(fieldName, e.target.value)}
        variant="outlined"
        size="small"
        {...rest}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </TextField>
    </Grid>
  );
};

export default FormSelectField;
